import { AreaAvailability } from "../../types/areaAvailability";
import { getEnvironmentProps } from "../../utils/environment";
import { dmnIdentity } from "../../utils/dmnIdentity";
import { errorHandler, apiFetchNotOkHandler } from "../errorHandler";

type GetAreaAvailabilityProps = {
  selectedDate: Date;
  selectedDuration: number;
  selectedNumPeople: number;
  selectedTime: string;
  selectedType: string;
  venueId: string;
};
export const getAreaAvailability = async ({
  selectedDate,
  selectedDuration,
  selectedNumPeople,
  selectedTime,
  selectedType,
  venueId
}: GetAreaAvailabilityProps): Promise<AreaAvailability | undefined> => {
  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  const paramsObj = {
    date: selectedDate.toISOString().split("T")[0],
    duration: `${selectedDuration}`,
    num_people: `${selectedNumPeople}`,
    time: selectedTime,
    type: selectedType,
    venue_id: venueId
  };
  const searchParams = new URLSearchParams(paramsObj);

  const URL = `${
    environmentVars?.COLLINS_API_BASE_URL
  }/availability/available-areas?${searchParams.toString()}`;

  try {
    const response = await fetch(URL, {
      cache: "no-cache",
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    if (response.ok) {
      return (await response.json()).data;
    }

    apiFetchNotOkHandler(response, "Error fetching area availability");
    return undefined;
  } catch (error) {
    errorHandler(error, "Error fetching area availability");

    return undefined;
  }
};
